import { useCallback, useEffect } from 'react'
import { lot as lotAPI } from '../utils/api'
import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
import { ILot } from '../types/lot'
import { List } from '../components/Lots'
import { Button } from '../components/UI/Buttons'
import { Container } from '../components/Container'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from '../hooks/useTypedSelector'
import { mainSetLoading } from '../store/actions/main'

export const Search = () => {
    const location = useLocation()
    const [lots, setLots] = useState<ILot[]>([])
    const dispatch = useDispatch()
    const { main } = useTypedSelector((s) => s)

    const getLots = useCallback(async () => {
        dispatch(mainSetLoading(true))
        try {
            await lotAPI
                .get({ search: location.state as string })
                .then((res) => setLots(res.data.rows))
        } catch (e) {
            console.error(e)
        }
        dispatch(mainSetLoading(false))
    }, [location.state, dispatch])

    useEffect(() => {
        getLots()
    }, [location.state, getLots])

    return (
        <Container>
            {lots.length ? (
                <List lots={lots}></List>
            ) : main.loading ? null : (
                <>
                    <div className="empty">
                        Sorry, no matches were found for your query.
                    </div>
                    <div className="empty">
                        <Link to="/">
                            <Button size="large">Back to home page</Button>
                        </Link>
                    </div>
                </>
            )}
        </Container>
    )
}
